import * as LabelPrimitive from '@radix-ui/react-label'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

/** Mono uppercase field label (prototype `.field > label`). variant="plain" for sentence-case labels. */
const labelVariants = cva(
	'leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
	{
		variants: {
			variant: {
				mono: 'font-mono text-label uppercase text-stone',
				plain: 'text-sm font-medium text-ink',
			},
		},
		defaultVariants: { variant: 'mono' },
	},
)

const Label = React.forwardRef<
	React.ElementRef<typeof LabelPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
		VariantProps<typeof labelVariants>
>(({ className, variant, ...props }, ref) => (
	<LabelPrimitive.Root
		ref={ref}
		className={cn(labelVariants({ variant }), className)}
		{...props}
	/>
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label, labelVariants }
